export default __webpack_public_path__ + "static/media/dhawan.2833922e.webp";